<form [formGroup]="multiSectionCheckboxForm">
  <div
    *ngIf="overrideDesiredAvailability$ | async"
    class="session-type-alert"
  >
    <iris-icon
      *ngIf="wizard.context?.in_person"
      name="location_on"
      colorToken="$color-dec-kelly-100">
    </iris-icon>
    <iris-icon
      *ngIf="!wizard.context?.in_person"
      name="videocam"
      colorToken="$color-dec-kelly-100">
    </iris-icon>

    <ng-container *ngIf="wizard.context?.in_person">
      We offer <b>in-person & video sessions</b>
    </ng-container>
    <ng-container *ngIf="!wizard.context?.in_person">
      We only offer <b>video sessions</b>
    </ng-container>
    near {{ wizard.response.data.location.name }}
  </div>

  <ng-container *ngFor="let item of config.form">
    <ng-container *ngFor="let section of item.sections">
      <iris-form-field
        [label]="section.label"
        [showOptionalTag]="false"
        [attr.data-test]="section.label + '-label'"
      >
        <div [formGroupName]="item.name">
          <iris-checkbox
            [formControlName]="option.value"
            [attr.data-test]="'session-time-selection-' + option.value"
            *ngFor="let option of section.options"
          >
            {{option.label}}
          </iris-checkbox>
        </div>
      </iris-form-field>
    </ng-container>
  </ng-container>
</form>
